import { HttpClient } from '@angular/common/http';
import { Injectable, Injector, Signal, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { EnvironmentService } from '@scripts/woo_services.module/EnvironmentService';
import { OmsBookableCheck, wooId } from '@scripts/woo_services.module/shared-types';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiState } from './models/api-state.type';

@Injectable({
  providedIn: 'root',
})
export class OMSBookableChecksAPIService {
  private http = inject(HttpClient);
  private env = inject(EnvironmentService);
  private injector = inject(Injector);

  getBookableChecks(campaignId: wooId): Signal<ApiState<OmsBookableCheck[]>> {
    return this.toApiState(
      this.http.get<OmsBookableCheck[]>(`${this.env.apiUrl}/campaigns/${campaignId}/oms_bookable_checks`),
    );
  }

  private toApiState<T>(request$: Observable<T>): Signal<ApiState<T>> {
    return toSignal(
      request$.pipe(
        map((data): ApiState<T> => ({ status: 'success', data })),
        catchError((error: unknown): Observable<ApiState<T>> => of({ status: 'error', error })),
      ),
      { initialValue: { status: 'loading' } as ApiState<T>, injector: this.injector },
    );
  }
}
